import { combineReducers } from 'redux'
import {
  KREDENSIAL_FETCH_ALL, KREDENSIAL_ADD, KREDENSIAL_EDIT, KREDENSIAL_DELL
} from '../actions/masterKredensialAction'

const list = (state = { isload: false, data: [] }, action) => {
  switch (action.type) {
      case KREDENSIAL_FETCH_ALL:
          return { isload: action.load, data: action.val }
      default:
          return state
  }
}
const addKredensial = (state = { val: [], load: false }, action) => {
  switch (action.type) {
      case KREDENSIAL_ADD:
          return { val: action.val, load: action.load }
      default:
          return state
  }
}

const EditKredensial = (state = { val: [], load: false }, action) => {
  switch (action.type) {
      case KREDENSIAL_EDIT:
          return { val: action.val, load: action.load }
      default:
          return state
  }
}
const DelKredensial = (state = { val: [], load: false }, action) => {
  switch (action.type) {
      case KREDENSIAL_DELL:
          return { val: action.val, load: action.load }
      default:
          return state
  }
}
const masterKredensial = combineReducers({
  list,
  addKredensial,
  DelKredensial,
  EditKredensial
})

export default masterKredensial